import styled from 'styled-components';

const AuthContainer = styled.div`
  border-radius: 0;
  margin: 0 auto;
  min-height: 100%;
  padding: 1rem 2.5rem;

  ${Styles.desktop`
    margin: 11rem auto 2rem;
    max-width: 40rem;
    padding: 3rem 2.5rem 3rem 2.5rem;
  `}

  h1, h2 {
    // These styles adjust title text on both sign-up and sign-in pages
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.base};
    line-height: 1;
    margin: 0 0 2rem 0;
    text-align: center;
  }
  hr {
    margin-bottom: 2rem;
    border-style: solid;
    border-width: 0.5px;
  }
`;

export default AuthContainer;
